import React from "react";
import { Button, Navbar } from "@blueprintjs/core";

import { Link } from "react-router-dom";

import * as ROUTES from "../../constants/routes";

import SignOutButton from "../Signout";

import { AuthUserContext } from "../Session";

const Navigation = () => (
  <div>
    <AuthUserContext.Consumer>
      {(authUser) => (authUser ? <NavigationAuth /> : <NavigationNonAuth />)}
    </AuthUserContext.Consumer>
  </div>
);

const NavigationAuth = () => (
  <Navbar>
    <Navbar.Group>
      <Navbar.Heading>Thakaa Apollo</Navbar.Heading>
      <Navbar.Divider />
      <Link to={ROUTES.HOME}>
        <Button className="bp3-minimal" icon="calendar" text="Calendar" />
      </Link>
      <Navbar.Divider />
      <Link to={ROUTES.EVENTS}>
        <Button className="bp3-minimal" icon="th-list" text="Events" />
      </Link>
    
      <Navbar.Divider />
      <Link to={ROUTES.USERPROFILE}>
        <Button className="bp3-minimal" icon="person" text="User Profiles" />
      </Link>
      <Navbar.Divider />
      <Link to={ROUTES.CHALLENGES}>
        <Button className="bp3-minimal" icon="applications" text="Challenges" />
      </Link>
      <Navbar.Divider />
      <Link to={ROUTES.CONSULTATIONS}>
        <Button
          className="bp3-minimal"
          icon="applications"
          text="Consultations"
        />
      </Link>
      <Navbar.Divider />
      {/* <Link to={ROUTES.CHECKIN}>
        <Button className="bp3-minimal" icon="home" text="Check-In" />
      </Link>*/}
    </Navbar.Group>
    <Navbar.Group align="right">
      <Link to={ROUTES.TEAMMEMBER}>
        <button className="bp3-button bp3-minimal bp3-icon-user" />
      </Link>
      <button className="bp3-button bp3-minimal bp3-icon-notifications" />
      <SignOutButton />
    </Navbar.Group>
  </Navbar>
);

const NavigationNonAuth = () => (
  <Navbar>
    <Navbar.Group>
      <Navbar.Heading>Thakaa Apollo</Navbar.Heading>
      <Navbar.Divider />
      <Link to={ROUTES.HOME}>
        <Button className="bp3-minimal" icon="home" text="Home" />
      </Link>
      <Link to={ROUTES.SIGN_UP}>
        <Button className="bp3-minimal" icon="document" text="Sign Up" />
      </Link>
      <Link to={ROUTES.SIGN_IN}>
        <Button className="bp3-minimal" icon="document" text="Sign In" />
      </Link>
      <Navbar.Divider />
    </Navbar.Group>
    <Navbar.Group align="right">
      <button className="bp3-button bp3-minimal bp3-icon-user" />
      <button className="bp3-button bp3-minimal bp3-icon-notifications" />
    </Navbar.Group>
  </Navbar>
);

export default Navigation;
